// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__vM8dI","btnYellow":"styles_btnYellow__ILcKz"};